import countryList from '@/utils/tools/country'
import { rules } from '@/utils/tools/checkout'
import { i18n } from '@/i18n'
import { deepClone, isEmptyValue } from '@/utils/tools/utils'
import { getStateList } from '@/views/checkout/api'
import { APPLE_PAY, GOOGLE_PAY } from '@/enums/methods'

const formSaveRules = {
  cardNumber: [
    {
      required: true,
      whitespace: true,
      message: i18n.t('message.common.inputPlaceholder', {
        field: i18n.t('message.checkout.cardNumber').toLowerCase()
      })
    },
    {
      validator: rules.cardNumber,
      trigger: 'blur'
    }
  ],
  expiredDate: [
    {
      required: true,
      whitespace: true,
      message: i18n.t('message.common.inputPlaceholder', {
        field: i18n.t('message.checkout.expiredDate').toLowerCase()
      })
    },
    {
      validator: rules.monthYear,
      trigger: 'blur'
    }
  ],
  cvv: [
    {
      required: true,
      whitespace: true,
      message: i18n.t('message.common.inputPlaceholder', {
        field: i18n.t('message.checkout.cvv').toLowerCase()
      })
    },
    {
      validator: rules.cvv,
      trigger: 'blur'
    }
  ],
  cardFirstName: [
    {
      required: true,
      whitespace: true,
      message: i18n.t('message.common.inputPlaceholder', {
        field: i18n.t('message.checkout.cardName').toLowerCase()
      })
    }
  ],
  cardLastName: [
    {
      required: true,
      whitespace: true,
      message: i18n.t('message.common.inputPlaceholder', {
        field: i18n.t('message.checkout.cardName').toLowerCase()
      })
    }
  ],
  email: [
    {
      type: 'email',
      message: i18n.t('message.checkout.correctEmailAddressTip')
    }
  ]
}

export const showDocument = (country) => {
  switch (country) {
    case 'BR': {
      return 'CPF'
    }
    case 'CL': {
      return 'RUT'
    }
    case 'PE': {
      return 'DNI'
    }
    case 'ZA': {
      return 'ID / Passport'
    }
    default: {
      return ''
    }
  }
}
/**
 * 初始化区号
 */
export const initPhoneCode = (_this, country) => {
  const obj = {}
  countryList.forEach((item) => {
    obj['+' + item.phone_code] = '+' + item.phone_code
    if (country === item.code && !_this.form.phone) {
      _this.form.phoneCode = '+' + item.phone_code
    }
  })
  _this.phoneCodeList = Object.keys(obj)
}

export const initBankList = (selectMethod, country) => {
  if (selectMethod && selectMethod.child && selectMethod.child.length > 0) {
    const methodSubItem = selectMethod.child.find((item) => item.country === country)
    return methodSubItem ? methodSubItem?.nameCode || [] : []
  }
  return []
}

// 初始化可用的支付方式
export const initCanUseMethod = (_this, country) => {
  const methodList = _this.orderDetails?.paymentLogos
  const checkoutPaymentsShow = _this.orderDetails?.checkoutPaymentsShow
  const array = []
  if (methodList && methodList.length > 0) {
    methodList.forEach((item) => {
      if (item.supportCountry && (item.supportCountry.includes('ALL') || item.supportCountry.includes(country))) {
        if (checkSupport(item, true, _this.orderDetails)?.isDisplay) {
          if (+checkoutPaymentsShow == 0) {
            array.push(item)
          } else {
            if (item.code === 'CARD') {
              if (String(checkoutPaymentsShow) !== '2') {
                array.push(item)
              }
            } else {
              if (String(checkoutPaymentsShow) !== '1') {
                array.push(item)
              }
            }
          }
        }
      }
    })
  }
  if (
    !array[_this.chosenPaymentMethodIndex] ||
    array.length < _this.chosenPaymentMethodIndex ||
    _this.chosenPaymentMethod?.cardName !== array[_this.chosenPaymentMethodIndex]?.cardName
  ) {
    _this.chosenPaymentMethodIndex = 0
    _this.chosenPaymentMethod = array[0]
  }
  _this.disable = array <= 0
  return array
}

/**
 * 根据配置展示账单信息逻辑，控制账单的显示隐藏和不能修改
 * @param order
 * @param displayItems
 * @param disableItems
 */
export const setBillingEditDisplay = (order, displayItems, disableItems) => {
  if (!order.editorialDisplay) {
    return
  }
  if (+order.editorialDisplay === 1) {
    Object.keys(displayItems).forEach((key) => {
      disableItems[key] = !isEmptyValue(order?.billing[key])
    })
  } else {
    Object.keys(displayItems).forEach((key) => {
      displayItems[key] = isEmptyValue(order?.billing[key])
    })
  }
}

// 设置requiredFields
export const initRequiredFields = (_this, selectMethod) => {
  if (selectMethod && selectMethod.requiredFields) {
    _this.formRules = deepClone(formSaveRules)
    const paramsList = selectMethod.requiredFields
    paramsList.forEach((param) => {
      if (selectMethod.requiredFields.includes(param)) {
        if (param === 'email') {
          _this.$set(_this.formRules, param, [
            {
              required: true,
              whitespace: true,
              type: 'email',
              message: i18n.t('message.checkout.correctEmailAddressTip')
            }
          ])
        } else {
          _this.$set(_this.formRules, param, [
            {
              required: true,
              whitespace: true,
              message: _this.$t('message.common.inputPlaceholder', {
                field: _this.$t(`message.checkout.${param}`).toLowerCase()
              })
            }
          ])
        }
      }
    })
    if (selectMethod?.child && selectMethod?.child.length > 0) {
      _this.$set(_this.formRules, 'extension.code', [
        {
          required: true,
          whitespace: true,
          message: _this.$t('message.common.selectPlaceholder', {
            field: _this.$t(getSubSelectMethodBackName(selectMethod)).toLowerCase()
          })
        }
      ])
    }
    if (selectMethod?.otherOptions && selectMethod?.otherOptions.length > 0) {
      selectMethod?.otherOptions.forEach((item) => {
        _this.$set(_this.formRules, `extension.otherOptions.${item.code}`, [
          {
            required: true,
            whitespace: true,
            message: _this.$t('message.common.inputPlaceholder', {
              field: item?.name
            })
          }
        ])
      })
    }
  } else {
    _this.formRules = deepClone(formSaveRules)
  }
}

export const initExtensionRules = (_this, value) => {
  const obj = { ..._this.form.extension, code: value }
  if (value) {
    const item = _this.bankList.find((item) => item.code === value)
    _this.bankTemplateList = item?.data || []
    _this.bankTemplateList.forEach((item) => {
      obj[item.param] = ''
    })
    _this.form.extension = obj
    _this.bankTemplateList.forEach((item) => {
      _this.$set(_this.formRules, `extension.${item.param}`, [
        {
          required: true,
          whitespace: true,
          message: _this.$t('message.common.inputPlaceholder', {
            field: item.title
          })
        }
      ])
    })
  } else {
    _this.bankTemplateList = []
  }
}

// select 框搜索过滤
export const isFilterOption = (value, option) => {
  if (option?.keyCode) {
    return option?.keyCode.toUpperCase().includes(String(value).toUpperCase())
  }
  return false
}

// 获得国家文本国际化 用于显示
export const getCountryNameText = (country) => {
  // return country?.translations[app.currentLan] || country.name
  return country.name
}

// 得到一个默认的账单国家用于筛选支付方式(作用是保持原有逻辑不变)
export const getDefaultCountry = (orderDetails) => {
  // 直接获取国家
  let country = orderDetails?.paymentCountry
  if (country) {
    return country
  }
  // 根据账单国家获取
  country = orderDetails?.billing?.country
  if (country) {
    return country
  }

  if (orderDetails?.paymentLogos && orderDetails?.paymentLogos.length > 0) {
    if (orderDetails?.paymentLogos[0]?.supportCountry && orderDetails?.paymentLogos[0]?.supportCountry.length > 0) {
      country = orderDetails?.paymentLogos[0]?.supportCountry[0]
      // 当国家是all的情况
      if (country === 'ALL') {
        country = 'US'
      }
    }
  }
  return country
}

// 初始化支付国家下拉框列表
export const initCountryOptions = (orderDetails, form, componentFunc) => {
  form.paymentCountry = getDefaultCountry(orderDetails)
  let allList = []
  let localList = []
  let supportCountry = []
  if (orderDetails?.paymentLogos?.length > 0) {
    orderDetails.paymentLogos.forEach((item) => {
      if (item.supportCountry) {
        supportCountry = supportCountry.concat(item.supportCountry)
      }
    })
  }
  if (supportCountry.length > 0) {
    if (form.paymentCountry) {
      supportCountry.unshift(form.paymentCountry)
    }
    localList = countryList.filter((item) => supportCountry.includes(item.code))

    allList = supportCountry.includes('ALL') ? countryList.filter((item) => !supportCountry.includes(item.code)) : []

    if (componentFunc) {
      componentFunc(allList, localList)
    }
  }
}

// 初始化支付方式
export const initTopMethodList = (_this) => {
  _this.topMethodsIndex = []
  _this.topMethods = _this.canSelectMethods
  if (_this.topMethods.length > 3) {
    _this.topMethods = _this.topMethods.slice(0, 3)
  }
  for (let i = 0; i < _this.topMethods.length; i++) {
    _this.topMethodsIndex.push(i)
  }
}

/**
 *  是否显示账单信息,有通道不需要显示账单信息里面内容
 */
export const isShowBillingInfo = (displayItems) => {
  if (displayItems && Object.keys(displayItems).length > 0) {
    const displayItem = Object.keys(displayItems).filter((item) => item !== 'country' && item !== 'test')
    return displayItems && displayItem?.some((key) => displayItems[key])
  }
  return false
}

/**
 * 保持时间显示为两位数
 * @param {*} second
 * @returns
 */
export const initSecondDisplay = (second) => {
  if (String(second).length === 1) {
    return `0${second}`
  } else {
    return second
  }
}

export const isShowEmoji = () => {
  return navigator.platform.indexOf('Win') !== 0
}

/**
 * 用于显示卡片的图标
 */
export const displayCardIcon = (card) => {
  return `${card?.logoUrl || `data:image/png;base64,${card?.logo}`}`
}

export const stateControl = (_this, country) => {
  _this.stateDisable = true
  getStateList(country).then((res) => {
    _this.stateList = res
    _this.stateDisable = false
  })
}

export const documentControl = (_this, country) => {
  if (_this.formRules.document) {
    const countryList = ['AR', 'BR', 'CL', 'CO', 'ZA', 'UY', 'PY', 'PA', 'GT']
    _this.formRules.document[0].required = countryList.includes(country)
    if (country?.toUpperCase() === 'BR') {
      _this.formRules.document[1] = {
        validator: (rule, value, callback) => {
          if (!/^(\d{3}\.\d{3}\.\d{3}-\d{2}|\d{11})$/.test(value)) {
            callback(new Error(i18n.t('message.common.correctFormat', { example: '12345678901, 123.456.789-01' })))
            return
          }
          callback()
        },
        trigger: 'blur'
      }
    } else {
      _this.formRules.document.length = 1
    }

    _this.refreshFormItem = false
    _this.$nextTick(() => {
      _this.refreshFormItem = true
    })
  }
}

/**
 * 检测Apple pay和google pay环境, isTraversal true 是显示所有支付方式使用, false是检测当前支付方式是否支持
 * @returns {boolean}
 */
export const checkSupport = (cardInfo, isTraversal, orderDetails) => {
  // 是否是我们自己的ApplePay
  let isOurApplePay = false
  // 是否是ApplePay
  let isApplePay = false
  // 是否是我们自己的GooglePay
  let isOurGooglePay = false
  // 是否是GooglePay
  let isGooglePay = false
  // 用于表示当前支付方式是否显示
  let isDisplay = true
  const specified = orderDetails?.specified
  if (cardInfo.code === APPLE_PAY) {
    isApplePay = true
    isOurApplePay = !!orderDetails?.wg?.apple
    isDisplay = !isOurApplePay ? !!orderDetails?.sp?.supportApplePay : true
  } else if (cardInfo.code === GOOGLE_PAY) {
    isGooglePay = true
    isOurGooglePay = !!orderDetails?.wg?.google
    isDisplay = !isOurGooglePay ? !!orderDetails?.sp?.supportGooglePay : true
  }
  if (isTraversal) {
    if (cardInfo.code !== APPLE_PAY && cardInfo.code !== GOOGLE_PAY) {
      if (specified === APPLE_PAY) {
        isDisplay = false
      } else if (specified === GOOGLE_PAY) {
        isDisplay = false
      }
    } else {
      if (String(cardInfo.isRedirect) === '1') {
        isDisplay = true
      }
      if (cardInfo.code === APPLE_PAY && specified === GOOGLE_PAY) {
        isDisplay = false
      } else if (cardInfo.code === GOOGLE_PAY && specified === APPLE_PAY) {
        isDisplay = false
      } else {
      }
    }
  }

  return {
    isOurApplePay,
    isOurGooglePay,
    isApplePay,
    isGooglePay,
    isDisplay
  }
}
/**
 * 根据条件获取checkSupport中的结果
 * @returns {boolean}
 */
export const checkSupportResults = (_this, cardInfo, isOur, paymentMethod) => {
  if (!_this.orderDetails || !_this.chosenPaymentMethod) {
    return false
  }
  const support = checkSupport(cardInfo, false, _this.orderDetails)
  if (paymentMethod === APPLE_PAY) {
    if (isOur) {
      return support.isDisplay && support.isOurApplePay && support.isApplePay
    } else {
      return support.isDisplay && !support.isOurApplePay && support.isApplePay
    }
  }
  if (paymentMethod === GOOGLE_PAY) {
    if (isOur) {
      return support.isDisplay && support.isOurGooglePay && support.isGooglePay
    } else {
      return support.isDisplay && !support.isOurGooglePay && support.isGooglePay
    }
  }
  return false
}

// 获取子选择框的 label
export const getSubSelectMethodBackName = (selectMethod) => {
  if (selectMethod) {
    switch (selectMethod.code) {
      case 'MOBILEMONEY':
        return 'message.checkout.mobileMoneyOperator'
      case 'USSD':
        return 'message.checkout.bank'
      default:
        return ''
    }
  }
  return ''
}

// 交易结果统一处理
export const toTransactionResult = (_this, res, id, isQrCode = false) => {
  if (res.status === 301) {
    window.location.href = res.redirectUrl
    return
  }
  let name = ''
  if (isQrCode && +res.status === 200) {
    return
  }
  if (+res.status === 201) {
    _this.setErrorTips(res?.message)
    return
  }
  if (+res.status === 100) {
    name = 'CheckoutSuccess'
  } else if (+res.status === 102) {
    if (!isQrCode) {
      name = 'CheckoutPending'
    }
  } else {
    name = 'CheckoutFailed'
  }
  if (name) {
    _this.$router.push({
      name,
      params: { id }
    })
  }
}
